import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { AppLoad } from "../../../core/AppLoad";
import { useHistory, Link, NavLink } from "react-router-dom";
import { AppConfig } from "../../../app-state";
import { Icon } from "../../../core/Icon";
import { FormGroup } from "../../../core/Form";
import { Checkbox } from "../../../core/Checkbox";
import { SubmitErrors } from "../../../core/SubmitErrors";
import { SubmitButton } from "../../../core/SubmitButton";
const submitErrorsDictionary = {
    email_used: "Pro uvedený email už existuje účet"
};
export const RegisterTrust = (props) => {
    // const { state, dispatch } = useContext(AppStateContext);
    const [loadState, setLoadState] = useState('idle');
    const [submitErrors, setSubmitErrors] = useState([]);
    const { register, handleSubmit, errors, setValue } = useForm();
    let history = useHistory();
    const onSubmit = (data) => {
        setLoadState('submitting');
        setSubmitErrors([]);
        data.role = "trust";
        //Hello again   
        AppLoad(AppConfig.APIUrl + 'public/auth/register', data).then((Response) => {
            if (Response.status == 'error') {
                setSubmitErrors(Response.errors);
            }
            else if (Response.status == 'ok') {
                history.push('/cs/proces/registrace/dokonceno');
            }
            setLoadState('idle');
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "navbar" },
            React.createElement("div", { className: "container" },
                React.createElement("div", { className: "navbar-inner" },
                    React.createElement(NavLink, { to: "/cs/proces/registrace", className: "back-link" },
                        React.createElement("span", { className: "icon", "aria-hidden": true }),
                        React.createElement("span", { className: "text" }, "Zp\u011Bt na p\u0159edchoz\u00ED krok"))))),
        React.createElement("div", { className: "process-master-form" },
            React.createElement("div", { className: "register-challenge" },
                React.createElement("h1", null, "Registrace v\u00EDce \u00FA\u010Dastn\u00EDk\u016F"),
                React.createElement("form", { onSubmit: handleSubmit(onSubmit), className: "form" },
                    React.createElement("fieldset", { disabled: loadState == 'submitting' },
                        React.createElement("legend", { className: "sr-only" }, "Formul\u00E1\u0159"),
                        React.createElement(SubmitErrors, { errors: submitErrors, dictionary: submitErrorsDictionary }),
                        React.createElement(FormGroup, { id: "fullname", label: "Jm\u00E9no a p\u0159\u00EDjmen\u00ED zastupuj\u00EDc\u00ED osoby", error: errors.fullname && 'Prosím vyplňte' },
                            React.createElement("input", { className: "textfield", id: "fullname", ref: register({ required: true }), name: "fullname", type: "text" })),
                        React.createElement(FormGroup, { id: "email", label: "Emailov\u00E1 adresa", error: errors.email && 'Prosím vyplňte' },
                            React.createElement("input", { className: "textfield", id: "email", ref: register({ required: true }), name: "email", type: "text" })),
                        React.createElement(FormGroup, { id: "heslo", label: "Heslo", error: errors.password && 'Prosím vyplňte' },
                            React.createElement("input", { className: "textfield", id: "heslo", ref: register({ required: true }), name: "password", type: "password" })),
                        React.createElement(FormGroup, { id: "phone", label: "Telefonn\u00ED kontakt", error: errors.phone && 'Prosím vyplňte' },
                            React.createElement("input", { className: "textfield", id: "phone", ref: register({ required: true }), name: "phone", type: "text" })),
                        React.createElement("div", { className: "mb-30" },
                            React.createElement(Checkbox, { id: "agreed", name: "agreed", cssWrapper: "mb-0", innerRef: register({ required: true }), error: errors.agreed && 'Je nutné vyjádřit souhlas se zpracováním osobních údajů.' },
                                React.createElement(React.Fragment, null,
                                    React.createElement("span", null, "Souhlas\u00EDm se "),
                                    React.createElement(Link, { className: "hyperlink", target: "_blank", to: "/cs/sekce/souhlas-se-zpracovanim-osobnich-udaju" },
                                        "zpracov\u00E1n\u00EDm osobn\u00EDch \u00FAdaj\u016F.",
                                        React.createElement(Icon, { c: ['external', 10, 10] }))))),
                        React.createElement("div", { className: "text-right" },
                            React.createElement(SubmitButton, { label: "Pokra\u010Dovat", loadState: loadState }))))))));
};
